<template>
	<div id="login" class="col-4 offset-4">
		<vue-headful
				:title="title">
		</vue-headful>
		<FeedbackPanel></FeedbackPanel>
		<div class="card">
			<div class="card-header text-center">Login to 3DS</div>
			<form class="card-body" @submit.prevent="login">
				<div class="form-group row">
					<label for="username">Username</label>
					<input v-model="username" type="text" class="form-control" id="username" placeholder="Username">
					<!--<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>-->
				</div>
				<div class="form-group row b-table-stacked">
					<label for="password">Password</label>
					<input v-model="password" type="password" class="form-control" id="password" placeholder="Password">
				</div>
				<div class="form-group row">
					<button class="btn btn-primary">Login</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import {mapActions, mapGetters} from 'vuex'
import FeedbackPanel from '../components/FeedbackPanel'

Vue.use(VueAxios, axios)

export default {
	name: "Login",
	components: {FeedbackPanel},
	data() {
		return {
			username: '',
			password: ''
		}
	},
	computed: {
		...mapGetters({
			getErrors: 'get_errors',
			nextRoute: 'get_next_route'
		}),
		title: function () {
			return 'Welcome To Danox 3DS'
		}
	},
	methods: {
		...mapActions({
			pushError: 'push_error',
			setNextRoute: 'set_next_route',
			clearErrors: 'clear_errors',
			_login: 'login'
		}),
		login: function () {
			this.clearErrors()
			let that = this
			Vue.axios.post('/3ds/api/login', {
				"username": this.username,
				"password": this.password
			})
				.then(value => {
					// console.log(JSON.stringify(value))
					let token = value.data.token;
					localStorage.setItem('token', token)
					this._login(token)
					if (this.nextRoute) {
						let route = this.nextRoute
						this.setNextRoute(null)
						this.$router.push(route)
					} else {
						this.$router.push('/companies')
					}
				})
				.catch(reason => {
					console.log(JSON.stringify(reason))
					if (reason.response && reason.response.data) {
						this.pushError({
							'message': reason.response.data.message ? reason.response.data.message : reason.response.data.title,
							'type': 'WARNING'
						})
					}
				})
		}
	},
	mounted: function () {
		this.$emit('set-show-sidebar', {
			showSidebar: false
		})
	},
	destroyed: function () {
		this.$emit('set-show-sidebar', {
			showSidebar: true
		})
	}
}
</script>

<style scoped>

#login {
    padding-top: 5em;
}

.card-body {
    margin: 0 1em 0 1em;
}
</style>